import * as React from 'react'
import { connect } from 'react-redux'

import { StepByStepLoansAvatar, withExperiment } from 'embed/experiments'
import { MultiProductState } from 'embed/reducers'
import { SelectedApplicationStepState } from 'embed/reducers/ui'
import { uiSelectedApplicationStepSelector, uiSelectedProductSelector } from 'embed/selectors/ui'
import { Product } from 'even-ts-static'
import { assistantStepByStepText } from './assistantText'

const AvatarImg = require('./image/avatar.png')
const styles = require('./styles.scss')

interface OwnProps {
  selectedVariantId?: string
}

interface StoreProps {
  product: Product
  stepsByProduct: SelectedApplicationStepState
}

type Props = OwnProps & StoreProps

const AssistantView = ({ product, stepsByProduct, selectedVariantId }: Props) => {
  if (selectedVariantId !== StepByStepLoansAvatar.variants.Avatar.id) {
    return null
  }
  const step = stepsByProduct[product]
  const copyText = assistantStepByStepText[product]?.[step]
  if (!copyText) {
    return null
  }
  return (
    <div className={styles.avatarContainer}>
      <img src={AvatarImg} alt="Avatar" height="64" />
      {copyText}
    </div>
  )
}

const mapStateToProps = (state: MultiProductState) => ({
  product: uiSelectedProductSelector(state),
  stepsByProduct: uiSelectedApplicationStepSelector(state),
})

export const Assistant = withExperiment(StepByStepLoansAvatar)(connect(mapStateToProps)(AssistantView))
